import React from 'react';
import { Bell, Search, Menu } from 'lucide-react';
import { Link } from 'react-router-dom';
interface HeaderProps {
  onMenuClick: () => void;
}
export function Header({
  onMenuClick
}: HeaderProps) {
  return <header className="h-16 bg-white border-b border-gray-200 flex items-center justify-between px-6" data-id="element-73">
      <div className="flex items-center gap-4 flex-1" data-id="element-74">
        <button onClick={onMenuClick} className="lg:hidden p-2 text-gray-600 hover:bg-gray-100 rounded-lg transition-colors" data-id="element-75">
          <Menu className="w-6 h-6" data-id="element-76" />
        </button>
        <div className="flex-1 max-w-xl" data-id="element-77">
          <div className="relative" data-id="element-78">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" data-id="element-79" />
            <input type="text" placeholder="Buscar..." className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8BC4C3] focus:border-transparent" data-id="element-80" />
          </div>
        </div>
      </div>
      <div className="flex items-center gap-4" data-id="element-81">
        <button className="relative p-2 text-gray-600 hover:bg-gray-100 rounded-lg transition-colors" data-id="element-82">
          <Bell className="w-5 h-5" data-id="element-83" />
          <span className="absolute top-1.5 right-1.5 w-2 h-2 bg-red-500 rounded-full" data-id="element-84" />
        </button>
        <Link to="/profile" className="flex items-center gap-3 hover:opacity-80 transition-opacity" data-id="element-85">
          <div className="text-right hidden sm:block" data-id="element-86">
            <p className="text-sm font-semibold text-gray-900" data-id="element-87">Admin</p>
            <p className="text-xs text-gray-600" data-id="element-88">admin@idreamy.com</p>
          </div>
          <div className="w-10 h-10 bg-gradient-to-br from-[#8BC4C3] to-[#2C4A6B] rounded-full flex items-center justify-center text-white font-semibold" data-id="element-89">
            A
          </div>
        </Link>
      </div>
    </header>;
}